/* eslint-disable */

<template>
  <div>
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row" :class="{ 'cursor-drag': draggingCard === true }">
        <div class="vx-col lg:w-5/12 md:w-5/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4">Extensions</h3>
            <vue-draggable-container id="wordBank" class="wordBank">
              <h5 class="dragBlock font-semibold cursor-pointer" v-for="(control, index) in controls" :key="control + index">
                {{ control }}
              </h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-7/12 md:w-7/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="pt-0">
              <div class="vx-row mb-4">
                <div class="vx-col w-6/12 flex items-center">
                  <font-awesome-icon icon="fa-solid fa-mobile-screen" class="h-12 w-12 ml-2 mr-4 text-primary" />
                  <h2 class="font-bold">Company Managed Smart Phone</h2>
                </div>
                <div class="vx-col w-6/12 flex items-center">
                  <font-awesome-icon icon="fa-solid fa-server" class="h-12 w-12 mr-4 text-primary" />

                  <h2 class="font-bold">Data Center Terminal Server</h2>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputPhone0">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer0">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputPhone1">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer1">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputPhone2">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer2">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputPhone3">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer3">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputPhone4">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer4">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputPhone5">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer5">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputPhone6">
                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="inputServer6">
                  </vue-draggable-container>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';
import shuffle from 'shuffle-array';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      smart_phone: ['Screen Lock', 'Strong Password', 'Device Encryption', 'Remote Wipe', 'GPS Tracking'],

      data_center: ['Popup Blocker', 'Strong Password', 'Antivirus', 'Host Based Firewall', 'Sniffer', 'Man Trap', 'Proximity Badge'],

      controls: [
        'Screen Lock',
        'Strong Password',
        'Device Encryption',
        'Remote Wipe',
        'GPS Tracking',
        'Popup Blocker',
        'Strong Password',
        'Antivirus',
        'Host Based Firewall',
        'Sniffer',
        'Man Trap',
        'Proximity Badge',
      ],

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel();
        }
      }
    },
    /*  drag_error () {
        const now = new Date().getTime()
        if (this.last_drag_error === false || (now - this.last_drag_error) > 7500) {
          this.last_drag_error = now
          this.$vs.notify(
            {
              color: 'warning',
              title: 'Maximum One Answer Per Input',
              position: 'top-center',
              icon: 'feather',
              iconPack: 'icon-alert-circle',
            })
        }
      }, */
    markSimulation() {
      let totalScore = 0;

      for (let i = 0; i < 7; i++) {
        const inputPhone = document.getElementById(`inputPhone${i}`);

        if (inputPhone) {
          if (this.smart_phone.includes(inputPhone.textContent.trim())) {
            totalScore++;
            inputPhone.style.borderColor = '#28C76F';
            inputPhone.style.backgroundColor = '#28C76F';
          } else {
            inputPhone.style.borderColor = '#c93738';
            inputPhone.style.backgroundColor = '#c93738';
          }
        }
      }

      for (let i = 0; i < 7; i++) {
        const inputServer = document.getElementById(`inputServer${i}`);

        if (inputServer) {
          if (this.data_center.includes(inputServer.textContent.trim())) {
            totalScore++;
            inputServer.style.borderColor = '#28C76F';
            inputServer.style.backgroundColor = '#28C76F';
          } else {
            inputServer.style.borderColor = '#c93738';
            inputServer.style.backgroundColor = '#c93738';
          }
        }
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    draggable,
    Prism,
    shuffle,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.controls = shuffle(this.controls);
  },
};
</script>

<style scoped>
#wordBank {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.6rem;
  min-height: unset !important;
}
</style>
